module.exports = __webpack_public_path__ + "static/media/home_electric.d4bc0208.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_electric.svg
// module id = 542
// module chunks = 0